var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "135px",
    height: "40px",
    viewBox: "0 0 135 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GooglePlayBadge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 134.9999 0 134.9999 39.9999 0 39.9999"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 134.9999 0 134.9999 39.9999 0 39.9999"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 40 135 40 135 0 0 0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "61.0453132%",
    y1: "4.94615078%",
    x2: "26.512955%",
    y2: "71.8787395%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1FF",
    offset: "1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BEFF",
    offset: "26%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF",
    offset: "51%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFFF",
    offset: "76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E3FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "107.684729%",
    y1: "50%",
    x2: "-130.640394%",
    y2: "50%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD00",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500",
    offset: "78%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "86.2709832%",
    y1: "30.8725537%",
    x2: "-50.1798561%",
    y2: "136.108936%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C31162",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-18.82494%",
    y1: "-11.9103989%",
    x2: "42.0863309%",
    y2: "35.0790955%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DA771",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15CF74",
    offset: "48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06E775",
    offset: "80%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F076",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GooglePlayBadge",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(0.000000, 0.000200)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.9999,39.9999 L4.9999,39.9999 C2.2499,39.9999 -0.0001,37.7499 -0.0001,34.9999 L-0.0001,4.9999 C-0.0001,2.2499 2.2499,-0.0001 4.9999,-0.0001 L129.9999,-0.0001 C132.7499,-0.0001 134.9999,2.2499 134.9999,4.9999 L134.9999,34.9999 C134.9999,37.7499 132.7499,39.9999 129.9999,39.9999",
    id: "Fill-1",
    fill: "#000000",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.9999,-0.0001 L4.9999,-0.0001 C2.2499,-0.0001 -0.0001,2.2499 -0.0001,4.9999 L-0.0001,34.9999 C-0.0001,37.7499 2.2499,39.9999 4.9999,39.9999 L129.9999,39.9999 C132.7499,39.9999 134.9999,37.7499 134.9999,34.9999 L134.9999,4.9999 C134.9999,2.2499 132.7499,-0.0001 129.9999,-0.0001 M129.9999,0.7999 C132.3159,0.7999 134.1999,2.6839 134.1999,4.9999 L134.1999,34.9999 C134.1999,37.3159 132.3159,39.1999 129.9999,39.1999 L4.9999,39.1999 C2.6839,39.1999 0.7999,37.3159 0.7999,34.9999 L0.7999,4.9999 C0.7999,2.6839 2.6839,0.7999 4.9999,0.7999 L129.9999,0.7999",
    id: "Fill-4",
    fill: "#A6A6A6",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.4184,10.2431 C47.4184,11.0811 47.1704,11.7481 46.6734,12.2461 C46.1084,12.8381 45.3734,13.1341 44.4694,13.1341 C43.6034,13.1341 42.8664,12.8341 42.2614,12.2331 C41.6544,11.6331 41.3524,10.8881 41.3524,10.0001 C41.3524,9.1111 41.6544,8.3671 42.2614,7.7661 C42.8664,7.1661 43.6034,6.8661 44.4694,6.8661 C44.8984,6.8661 45.3104,6.9501 45.7004,7.1171 C46.0914,7.2851 46.4044,7.5081 46.6394,7.7871 L46.1114,8.3151 C45.7144,7.8411 45.1674,7.6031 44.4694,7.6031 C43.8374,7.6031 43.2914,7.8251 42.8304,8.2691 C42.3694,8.7141 42.1394,9.2901 42.1394,10.0001 C42.1394,10.7091 42.3694,11.2861 42.8304,11.7301 C43.2914,12.1751 43.8374,12.3961 44.4694,12.3961 C45.1394,12.3961 45.6974,12.1731 46.1454,11.7261 C46.4354,11.4351 46.6034,11.0311 46.6474,10.5111 L44.4694,10.5111 L44.4694,9.7901 L47.3764,9.7901 C47.4044,9.9471 47.4184,10.0971 47.4184,10.2431",
    id: "Fill-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4184,10.2431 C47.4184,11.0811 47.1704,11.7481 46.6734,12.2461 C46.1084,12.8381 45.3734,13.1341 44.4694,13.1341 C43.6034,13.1341 42.8664,12.8341 42.2614,12.2331 C41.6544,11.6331 41.3524,10.8881 41.3524,10.0001 C41.3524,9.1111 41.6544,8.3671 42.2614,7.7661 C42.8664,7.1661 43.6034,6.8661 44.4694,6.8661 C44.8984,6.8661 45.3104,6.9501 45.7004,7.1171 C46.0914,7.2851 46.4044,7.5081 46.6394,7.7871 L46.1114,8.3151 C45.7144,7.8411 45.1674,7.6031 44.4694,7.6031 C43.8374,7.6031 43.2914,7.8251 42.8304,8.2691 C42.3694,8.7141 42.1394,9.2901 42.1394,10.0001 C42.1394,10.7091 42.3694,11.2861 42.8304,11.7301 C43.2914,12.1751 43.8374,12.3961 44.4694,12.3961 C45.1394,12.3961 45.6974,12.1731 46.1454,11.7261 C46.4354,11.4351 46.6034,11.0311 46.6474,10.5111 L44.4694,10.5111 L44.4694,9.7901 L47.3764,9.7901 C47.4044,9.9471 47.4184,10.0971 47.4184,10.2431 Z",
    id: "Stroke-9",
    stroke: "#FFFFFF",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#FFFFFF",
    points: "52.0277 7.7372 49.2957 7.7372 49.2957 9.6392 51.7587 9.6392 51.7587 10.3602 49.2957 10.3602 49.2957 12.2622 52.0277 12.2622 52.0277 13.0002 48.5247 13.0002 48.5247 7.0002 52.0277 7.0002"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-13",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    points: "52.0277 7.7372 49.2957 7.7372 49.2957 9.6392 51.7587 9.6392 51.7587 10.3602 49.2957 10.3602 49.2957 12.2622 52.0277 12.2622 52.0277 13.0002 48.5247 13.0002 48.5247 7.0002 52.0277 7.0002"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#FFFFFF",
    points: "55.2787 12.9999 54.5077 12.9999 54.5077 7.7369 52.8317 7.7369 52.8317 6.9999 56.9547 6.9999 56.9547 7.7369 55.2787 7.7369"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-17",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    points: "55.2787 12.9999 54.5077 12.9999 54.5077 7.7369 52.8317 7.7369 52.8317 6.9999 56.9547 6.9999 56.9547 7.7369 55.2787 7.7369"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#FFFFFF",
    mask: "url(#mask-6)",
    points: "59.938 13 60.709 13 60.709 7 59.938 7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-21",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    mask: "url(#mask-6)",
    points: "59.938 13 60.709 13 60.709 7 59.938 7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#FFFFFF",
    mask: "url(#mask-6)",
    points: "64.1283 12.9999 63.3573 12.9999 63.3573 7.7369 61.6813 7.7369 61.6813 6.9999 65.8043 6.9999 65.8043 7.7369 64.1283 7.7369"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-23",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    mask: "url(#mask-6)",
    points: "64.1283 12.9999 63.3573 12.9999 63.3573 7.7369 61.6813 7.7369 61.6813 6.9999 65.8043 6.9999 65.8043 7.7369 64.1283 7.7369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7792,11.7221 C70.2232,12.1721 70.7662,12.3961 71.4092,12.3961 C72.0512,12.3961 72.5952,12.1721 73.0392,11.7221 C73.4832,11.2721 73.7062,10.6981 73.7062,10.0001 C73.7062,9.3021 73.4832,8.7271 73.0392,8.2781 C72.5952,7.8281 72.0512,7.6031 71.4092,7.6031 C70.7662,7.6031 70.2232,7.8281 69.7792,8.2781 C69.3362,8.7271 69.1132,9.3021 69.1132,10.0001 C69.1132,10.6981 69.3362,11.2721 69.7792,11.7221 M73.6092,12.2241 C73.0192,12.8311 72.2862,13.1341 71.4092,13.1341 C70.5322,13.1341 69.7992,12.8311 69.2102,12.2241 C68.6202,11.6181 68.3262,10.8771 68.3262,10.0001 C68.3262,9.1231 68.6202,8.3811 69.2102,7.7751 C69.7992,7.1691 70.5322,6.8661 71.4092,6.8661 C72.2812,6.8661 73.0122,7.1701 73.6052,7.7791 C74.1972,8.3881 74.4932,9.1281 74.4932,10.0001 C74.4932,10.8771 74.1982,11.6181 73.6092,12.2241",
    id: "Fill-24",
    fill: "#FFFFFF",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7792,11.7221 C70.2232,12.1721 70.7662,12.3961 71.4092,12.3961 C72.0512,12.3961 72.5952,12.1721 73.0392,11.7221 C73.4832,11.2721 73.7062,10.6981 73.7062,10.0001 C73.7062,9.3021 73.4832,8.7271 73.0392,8.2781 C72.5952,7.8281 72.0512,7.6031 71.4092,7.6031 C70.7662,7.6031 70.2232,7.8281 69.7792,8.2781 C69.3362,8.7271 69.1132,9.3021 69.1132,10.0001 C69.1132,10.6981 69.3362,11.2721 69.7792,11.7221 Z M73.6092,12.2241 C73.0192,12.8311 72.2862,13.1341 71.4092,13.1341 C70.5322,13.1341 69.7992,12.8311 69.2102,12.2241 C68.6202,11.6181 68.3262,10.8771 68.3262,10.0001 C68.3262,9.1231 68.6202,8.3811 69.2102,7.7751 C69.7992,7.1691 70.5322,6.8661 71.4092,6.8661 C72.2812,6.8661 73.0122,7.1701 73.6052,7.7791 C74.1972,8.3881 74.4932,9.1281 74.4932,10.0001 C74.4932,10.8771 74.1982,11.6181 73.6092,12.2241 Z",
    id: "Stroke-25",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    fill: "#FFFFFF",
    mask: "url(#mask-6)",
    points: "75.5751 12.9999 75.5751 6.9999 76.5131 6.9999 79.4291 11.6669 79.4631 11.6669 79.4291 10.5109 79.4291 6.9999 80.2011 6.9999 80.2011 12.9999 79.3961 12.9999 76.3461 8.1059 76.3121 8.1059 76.3461 9.2629 76.3461 12.9999"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-27",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    mask: "url(#mask-6)",
    points: "75.5751 12.9999 75.5751 6.9999 76.5131 6.9999 79.4291 11.6669 79.4631 11.6669 79.4291 10.5109 79.4291 6.9999 80.2011 6.9999 80.2011 12.9999 79.3961 12.9999 76.3461 8.1059 76.3121 8.1059 76.3461 9.2629 76.3461 12.9999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.936,30 L108.801,30 L108.801,17.499 L106.936,17.499 L106.936,30 Z M123.743,22.002 L121.604,27.422 L121.54,27.422 L119.32,22.002 L117.31,22.002 L120.64,29.577 L118.741,33.791 L120.687,33.791 L125.818,22.002 L123.743,22.002 Z M113.16,28.58 C112.55,28.58 111.697,28.274 111.697,27.518 C111.697,26.554 112.759,26.183 113.676,26.183 C114.495,26.183 114.882,26.361 115.38,26.601 C115.235,27.76 114.238,28.58 113.16,28.58 L113.16,28.58 Z M113.386,21.728 C112.035,21.728 110.636,22.324 110.057,23.642 L111.713,24.334 C112.067,23.642 112.726,23.417 113.418,23.417 C114.383,23.417 115.364,23.996 115.38,25.025 L115.38,25.154 C115.042,24.961 114.318,24.672 113.434,24.672 C111.648,24.672 109.831,25.653 109.831,27.486 C109.831,29.159 111.295,30.237 112.935,30.237 C114.189,30.237 114.882,29.674 115.315,29.014 L115.38,29.014 L115.38,29.979 L117.182,29.979 L117.182,25.186 C117.182,22.967 115.524,21.728 113.386,21.728 L113.386,21.728 Z M101.854,23.524 L99.2,23.524 L99.2,19.239 L101.854,19.239 C103.249,19.239 104.041,20.393 104.041,21.381 C104.041,22.35 103.249,23.524 101.854,23.524 L101.854,23.524 Z M101.806,17.498 L97.335,17.498 L97.335,30 L99.2,30 L99.2,25.264 L101.806,25.264 C103.874,25.264 105.907,23.766 105.907,21.381 C105.907,18.996 103.874,17.498 101.806,17.498 L101.806,17.498 Z M77.425,28.582 C76.136,28.582 75.057,27.503 75.057,26.021 C75.057,24.522 76.136,23.427 77.425,23.427 C78.697,23.427 79.696,24.522 79.696,26.021 C79.696,27.503 78.697,28.582 77.425,28.582 L77.425,28.582 Z M79.567,22.702 L79.503,22.702 C79.084,22.203 78.278,21.751 77.264,21.751 C75.137,21.751 73.187,23.62 73.187,26.021 C73.187,28.405 75.137,30.258 77.264,30.258 C78.278,30.258 79.084,29.807 79.503,29.291 L79.567,29.291 L79.567,29.903 C79.567,31.531 78.697,32.4 77.296,32.4 C76.152,32.4 75.443,31.579 75.153,30.886 L73.526,31.563 C73.993,32.69 75.233,34.076 77.296,34.076 C79.487,34.076 81.34,32.787 81.34,29.645 L81.34,22.009 L79.567,22.009 L79.567,22.702 Z M82.629,30 L84.497,30 L84.497,17.499 L82.629,17.499 L82.629,30 Z M87.252,25.876 C87.204,24.232 88.525,23.395 89.475,23.395 C90.217,23.395 90.845,23.766 91.055,24.297 L87.252,25.876 Z M93.052,24.458 C92.697,23.508 91.618,21.751 89.411,21.751 C87.22,21.751 85.399,23.475 85.399,26.005 C85.399,28.389 87.204,30.258 89.62,30.258 C91.569,30.258 92.697,29.066 93.165,28.373 L91.715,27.406 C91.231,28.115 90.571,28.582 89.62,28.582 C88.67,28.582 87.993,28.147 87.559,27.293 L93.245,24.941 L93.052,24.458 Z M47.744,23.057 L47.744,24.861 L52.061,24.861 C51.933,25.876 51.594,26.617 51.079,27.132 C50.45,27.761 49.467,28.454 47.744,28.454 C45.085,28.454 43.007,26.311 43.007,23.653 C43.007,20.995 45.085,18.851 47.744,18.851 C49.178,18.851 50.225,19.415 50.998,20.141 L52.271,18.868 C51.191,17.837 49.758,17.047 47.744,17.047 C44.102,17.047 41.041,20.012 41.041,23.653 C41.041,27.293 44.102,30.258 47.744,30.258 C49.709,30.258 51.191,29.613 52.351,28.405 C53.543,27.213 53.914,25.537 53.914,24.184 C53.914,23.766 53.882,23.379 53.817,23.057 L47.744,23.057 Z M58.822,28.582 C57.534,28.582 56.422,27.519 56.422,26.005 C56.422,24.474 57.534,23.427 58.822,23.427 C60.111,23.427 61.223,24.474 61.223,26.005 C61.223,27.519 60.111,28.582 58.822,28.582 L58.822,28.582 Z M58.822,21.751 C56.47,21.751 54.553,23.54 54.553,26.005 C54.553,28.454 56.47,30.258 58.822,30.258 C61.175,30.258 63.092,28.454 63.092,26.005 C63.092,23.54 61.175,21.751 58.822,21.751 L58.822,21.751 Z M68.136,28.582 C66.847,28.582 65.735,27.519 65.735,26.005 C65.735,24.474 66.847,23.427 68.136,23.427 C69.425,23.427 70.536,24.474 70.536,26.005 C70.536,27.519 69.425,28.582 68.136,28.582 L68.136,28.582 Z M68.136,21.751 C65.784,21.751 63.867,23.54 63.867,26.005 C63.867,28.454 65.784,30.258 68.136,30.258 C70.488,30.258 72.405,28.454 72.405,26.005 C72.405,23.54 70.488,21.751 68.136,21.751 L68.136,21.751 Z",
    id: "Fill-28",
    fill: "#FFFFFF",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(9.767131, 7.132352)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.672868513,0.407647533 C0.343337864,0.797267022 0.175197596,1.29811037 0.202868513,1.80764753 L0.202868513,23.9276475 C0.168842483,24.4380268 0.337762016,24.9411913 0.672868513,25.3276475 L0.742868513,25.4076475 L13.1328685,13.0176475 L13.1328685,12.7176475 L0.742868513,0.337647533 L0.672868513,0.407647533 Z",
    id: "Path",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2328685,17.1476475 L13.1328685,13.0176475 L13.1328685,12.7176475 L17.2328685,8.58764753 L17.3228685,8.64764753 L22.2328685,11.4276475 C23.6328685,12.2176475 23.6328685,13.5176475 22.2328685,14.3176475 L17.3428685,17.0976475 L17.2328685,17.1476475 Z",
    id: "Path",
    fill: "url(#linearGradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3528685,17.0876475 L13.1328685,12.8676475 L0.672868513,25.3276475 C1.25590109,25.8466184 2.12610849,25.8760457 2.74286851,25.3976475 L17.3528685,17.0876475",
    id: "Path",
    fill: "url(#linearGradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3528685,8.64764753 L2.74286851,0.347647533 C2.12983308,-0.137630962 1.25676624,-0.112324677 0.672868513,0.407647533 L13.1328685,12.8676475 L17.3528685,8.64764753 Z",
    id: "Path",
    fill: "url(#linearGradient-10)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/GooglePlayBadge.c336f3bbd36891406853d2281679903d.svg";
export { ForwardRef as ReactComponent };